import type { CSSProperties } from 'react';
import { useLanguage } from '../i18n';

const samples = [
  ['#f6f3ec', '#27364a', '#89a6b8', 'gallery.white'],
  ['#16181d', '#d9c7a3', '#6a482d', 'gallery.black'],
  ['#f7f5ee', '#395f57', '#d7b874', 'gallery.shadow'],
  ['#f4f1e8', '#98635a', '#2a3745', 'gallery.print'],
  ['#f7f7f3', '#9aa9bd', '#2e4057', 'gallery.exif'],
  ['#16181d', '#63737f', '#f3a35c', 'gallery.cinema'],
  ['#f7f5ef', '#5b6b46', '#d4c4a7', 'gallery.square'],
  ['#f3f3f1', '#101217', '#a4adb6', 'gallery.minimalBlack'],
  ['#f7f6f2', '#d19163', '#314e66', 'gallery.rounded'],
  ['#181a20', '#a53d43', '#e3d2b8', 'gallery.dark'],
  ['#f6f2ea', '#886f52', '#28323d', 'gallery.large'],
  ['#f9f8f4', '#3d5f7b', '#d7e0e4', 'gallery.clean']
];

export function ExampleGallery(): JSX.Element {
  const { t } = useLanguage();

  return (
    <section className="mx-auto mt-10 max-w-6xl px-4 pb-16 sm:px-6">
      <div className="mb-4 flex items-end justify-between gap-4">
        <div>
          <h2 className="text-sm font-semibold">{t('gallery.title')}</h2>
          <p className="mt-1 text-sm text-[color:var(--muted)]">{t('gallery.subtitle')}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {samples.map(([a, b, c, labelKey], index) => (
          <figure
            key={labelKey}
            className="group rounded-lg border border-[color:var(--line)] bg-[color:var(--panel)] p-2 transition hover:-translate-y-0.5 hover:shadow-frame"
          >
            <div
              className="sample-photo aspect-[4/5] rounded-md"
              style={
                {
                  '--sample-a': a,
                  '--sample-b': b,
                  '--sample-c': c
                } as CSSProperties
              }
            >
              <div className={`h-full w-full ${index % 3 === 0 ? 'p-4' : 'p-3'}`}>
                <div className="h-full rounded-[4px] border-[10px] border-[color:var(--panel)] shadow-[0_10px_26px_rgb(15_23_42_/_0.18)]" />
              </div>
            </div>
            <figcaption className="mt-2 truncate text-xs text-[color:var(--muted)]">{t(labelKey)}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
